import React, { AnimationEvent, useEffect, useRef } from 'react';

import { Container, Section } from './components';
import { useNavigateByName } from './hooks';
import { RouteDictionary } from './utils';

const REDIRECT_DELAY_MS = 100;

const App = () => {
  const navigate = useNavigateByName();
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, []);

  const handleAnimationEnd = (event: AnimationEvent<HTMLElement>) => {
    if (event.target !== event.currentTarget || timeoutRef.current) {
      return;
    }
    timeoutRef.current = setTimeout(() => {
      navigate(RouteDictionary.HOW_IT_WORKS);
    }, REDIRECT_DELAY_MS);
  };

  return (
    <Section className="main-section" onAnimationEnd={handleAnimationEnd}>
      <Container>{null}</Container>
    </Section>
  );
};

export default App;
